/**
 * useDocumentTitle — declarative wrapper for `document.title`.
 *
 * Two usage modes:
 *
 *   1. Inline on a page that has a static title:
 *        useDocumentTitle("Foundry");
 *
 *   2. Dynamic title (e.g. "Study: Q4 Demand Plan"):
 *        useDocumentTitle(study ? `Study: ${study.name}` : "Study");
 *
 * The hook always suffixes with " · UpSynQ" so multi-tab planners
 * can tell which app a tab belongs to at a glance.
 *
 * Resets to the default on unmount so a page that uses the hook
 * doesn't leave a stale title behind when the user navigates away.
 */
import { useEffect } from "react";

export const DEFAULT_TITLE = "UpSynQ — Unified Planning & Optimization Platform";
const SUFFIX = " · UpSynQ";

export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    const prev = document.title;
    if (title) {
      document.title = `${title}${SUFFIX}`;
    }
    return () => {
      document.title = prev;
    };
  }, [title]);
}
